<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>Geräte</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <div class="search">
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
    <input #search type="search" [(ngModel)]="searchText" (ngModelChange)="searchChanged()" class="search-input" placeholder="Bezeichnung, Kunde, Artikel..."/>
  </div>
  
  <ion-checkbox labelPlacement="end" [(ngModel)]="onlyThisAddress" (ngModelChange)="loadDevices()">Nur Geräte aus dieser Adresse anzeigen</ion-checkbox>

  @if(!isLoading && devices.length > 0){
    <div class="device-item" *ngFor="let device of devices" (click)="selectDevice(device)">
      <h3>Nummer: {{device.number}}</h3>
      <h2>{{device.description}}</h2>
      <h3>Artikel: {{device.articleName || '-'}}</h3>
      <h3>Kunde: {{device.addressName || '-'}}</h3>
    </div>
  }
  @else if(!isLoading && devices.length == 0){
    <p class="no-content">Keine Geräte gefunden</p>
  }
  @else {
    <section id="loading">
      <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
    </section>
  }

  <ion-infinite-scroll [disabled]="infiniteDisabled" (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content #infiniteScroll></ion-infinite-scroll-content>
  </ion-infinite-scroll>


</ion-content>
